var map = {
	"./10C.svg": 238,
	"./10D.svg": 239,
	"./10H.svg": 240,
	"./10S.svg": 241,
	"./2C.svg": 242,
	"./2D.svg": 243,
	"./2H.svg": 244,
	"./2S.svg": 245,
	"./3C.svg": 246,
	"./3D.svg": 247,
	"./3H.svg": 248,
	"./3S.svg": 249,
	"./4C.svg": 250,
	"./4D.svg": 251,
	"./4H.svg": 252,
	"./4S.svg": 253,
	"./5C.svg": 254,
	"./5D.svg": 255,
	"./5H.svg": 256,
	"./5S.svg": 257,
	"./6C.svg": 258,
	"./6D.svg": 259,
	"./6H.svg": 260,
	"./6S.svg": 261,
	"./7C.svg": 262,
	"./7D.svg": 263,
	"./7H.svg": 264,
	"./7S.svg": 265,
	"./8C.svg": 266,
	"./8D.svg": 267,
	"./8H.svg": 268,
	"./8S.svg": 269,
	"./9C.svg": 270,
	"./9D.svg": 271,
	"./9H.svg": 272,
	"./9S.svg": 273,
	"./AC.svg": 274,
	"./AD.svg": 275,
	"./AH.svg": 276,
	"./AS.svg": 277,
	"./Blue_Back.svg": 278,
	"./JC.svg": 279,
	"./JD.svg": 280,
	"./JH.svg": 281,
	"./JS.svg": 282,
	"./KC.svg": 283,
	"./KD.svg": 284,
	"./KH.svg": 285,
	"./KS.svg": 286,
	"./QC.svg": 287,
	"./QD.svg": 288,
	"./QH.svg": 289,
	"./QS.svg": 290,
	"./Red_Back.svg": 291,
	"./TC.svg": 292,
	"./TD.svg": 293,
	"./TH.svg": 294,
	"./TS.svg": 295
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 81;